export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6803.a0680f18.jpg";